import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import EmptyState from 'assets/images/reports-empty-state.webp';
import ResolveImage from 'components/ResolveImage';
import useMatchMedia from 'hooks/useMatchMedia';

import './TableEmptyState.styles.scss';

type TableEmptyStateProps = {
  className?: string;
  emptyMessage?: string;
};

const TableEmptyState: React.FC<TableEmptyStateProps> = (props) => {
  const { t } = useTranslation();

  const { className, emptyMessage = t('noDataAvailable') } = props;

  const isPhablet = useMatchMedia('isPhablet');

  const classes = classNames(
    'table-empty-state',
    { 'white-panel': isPhablet },
    className,
  );

  return (
    <div className={classes}>
      <ResolveImage src={EmptyState} asIllustration alt="No data available." />
      <p>{emptyMessage}</p>
    </div>
  );
};

export default TableEmptyState;
